import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import DialogConfirm from '../../../../dialog/DialogConfirm';
import { Alert } from '@mui/material';
import usePeriodicalReporMarking from '../../../../../hooks/periodical-report/usePeriodicalReporMarking';
import SelectLearningArea from '../SelectCustom/SelectLearningAreas';
import SelectYearLevel from '../SelectCustom/SelectYearLevel';

const DialogSyncMarkingData = ({ open, onClose }) => {
  const [form, setInputForm] = useState({});
  const [errors, setInputErrors] = useState(null);
  const [loading, toggleLoading] = useState(false);

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const { syncMarkingDataPeriodicalReportMarkingById } = usePeriodicalReporMarking();
  const onSave = async (e) => {
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = await syncMarkingDataPeriodicalReportMarkingById(form);
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
      }
    } finally {
      toggleLoading(false);
    }
  };

  return (
    <DialogConfirm
      id={'sync-marking-data'}
      open={open}
      title='Sync Marking Data'
      onCancel={onClose}
      onConfirm={onSave}
      loading={loading}
      maxWidth='xs'
    >
      <div className='grid grid-cols-3 items-center gap-4'>
        <Typography className='col-span-full'>
          This action will synchronize the report data for the current periodical.
        </Typography>
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          Year level
        </Typography>
        <div className='col-span-2'>
          <SelectYearLevel
            onChange={(e) => onChange('yearLevelId', e.target.value)}
            value={form.yearLevelId}
            error={errors?.yearLevelId}
            disabled={loading}
          />
        </div>
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          Learning area
        </Typography>
        <div className='col-span-2'>
          <SelectLearningArea
            onChange={(e) => onChange('elementId', e.target.value)}
            value={form.elementId}
            error={errors?.elementId}
            disabled={loading}
          />
        </div>
      </div>
      {errors && errors.message && (
        <Alert severity='error' className='mt-2' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogConfirm>
  );
};

export default DialogSyncMarkingData;
